































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IActivityStatus } from "@/@types/admin/activity-status";

import TvChoose from "@/components/apps-configuration/tv/setting/tv-choose.vue";
import DdCommand from "@/components/apps-configuration/tv/setting/forms/dd-command.vue";
import InputCommand from "@/components/apps-configuration/tv/setting/forms/input-command.vue";
import TvCommandsController from "@/modules/_mixins/administration/tv-commands-controller";
import StandartTable from "@/components/tables/standart-table.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    TvChoose,
    DdCommand,
    InputCommand,
    StandartTable,
  },
})
export default class TvCommands extends Mixins(TvCommandsController) {
  @Prop({ type: Array, default: () => [] }) tvs!: Array<IActivityStatus>;

  ddcommands = [
    "display_resolution",
    "boot_sequence_option",
    "application_channel_control",
    "tv_channel_ui",
    "tv_volume_ui",
    "tv_caption_ui",
    "tv_channel_attribute_floating_ui",
    "channel_lock",
    "key_delivery_to_simplink",
    "instant_power",
    "wol_w",
    "wol_m",
    "inband_data_service_mhp",
    "inband_data_service_mheg",
    "inband_data_service_hbbtv",
    "security_level",
    "wifi_screen_share",
    "smart_share",
    "smart_pairing",
    "dmr",
    "browser_https_security_level",
    "pcr_recovery",
    "mute_on_tv_input",
    "soft_ap_ui",
    "soft_ap",
    "rs232c",
    "https_xait_xml",
    "block_external_input",
    "block_ir",
    "block_local_key",
    "block_usb",
    "block_hidden_menu",
    "block_launcher",
    "block_hotkey",
    "clock_display",
    "teletext",
    "secure_mmr_pairing",
    "dial",
    "alljoyn",
    "clock_source",
  ];
  inpcommands = [
    "pcr_offset_in_ms",
    "room_number",
    "tv_name",
    "full_browser_start_page_url",
    "maximum_volume_level",
    "soft_ap_password",
    "alternative_lg_service_xml",
    "alternative_url",
    "installation_menu_password",
  ];
  tabIndex = 0;

  powers: Array<string> = ["0", "1", "2"];
  active_tvs: Array<string> = [];

  get commands(): Array<string> {
    return this.ddcommands.concat(this.inpcommands);
  }
}
